// extracted by mini-css-extract-plugin
export var closeButton = "_hr-2";
export var closeButtonIcon = "_hr-3";
export var lightboxContent = "_hr-1";
export var lightboxOverlay = "_hr-0";